module.exports = __webpack_public_path__ + "static/media/july-2022-roundtable.d5ef80e0.png";